import type React from "react"

// A page module as the runtime renders it: its component.
export type PageModule = {
  default: React.ComponentType<any>
}

// The page map: a page's module by its Inertia component name, raising on a
// name no page has.
export type PageResolver = (name: string) => PageModule

let registry: PageResolver | null = null

// The composition root registers the app's page map once, at boot. The
// adapter reads pages from here, so nothing under lib/ imports a page and
// the eager page map never sits on an import path a page is also on.
export function registerPages(resolve: PageResolver) {
  registry = resolve
}

export function resolvePage(name: string): PageModule {
  if (registry === null) {
    throw new Error("No pages are registered")
  }
  return registry(name)
}
